import React, { useState, useEffect, useRef } from 'react'
import {
  Container,
  Card,
  Button,
  Form,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import toast from 'react-hot-toast'
import { useAuth } from './AuthContext'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

export default function LoginSignup() {
  
  const { user, login, signUp } = useAuth()

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '270px' : '0px',
  )

  // useEffect(() => {
  //   if (!user) return

  //   const currentPath = window.location.pathname

  //   if (currentPath === '/LoginSignup') {
  //     if (user?.user_type === 'admin') {
  //       navigate('/Dashboard')
  //     } else if (user?.user_type === 'teacher') {
  //       navigate('/AssignClass')
  //     }
  //   }
  //   // If current path is anything else, do nothing — user stays on the same path
  // }, [user, navigate])

  useEffect(() => {
  if (!user) return

  if (window.location.pathname === '/LoginSignup') {
    if (user?.user_type === 'admin') {
      navigate('/Dashboard', { replace: true })
    } else if (user?.user_type === 'teacher') {
      navigate('/AssignClass', { replace: true })
    } else if (user?.user_type === 'parents') {
      navigate('/Student/List', { replace: true })
    }
  }
}, [user, ])


  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [isLogin, setIsLogin] = useState(true)
  // const [isMobileForgotPass, setIsMobileForgotPass] = useState(false)

  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    // name: '',
    email: '',
    password: '',
    confirm: '',
    user_type: '',
  })

  const forgotRef = useRef(null)
  const [openForgotModal, setOpenForgotModal] = useState(false)

  // const   handleParentLogin = () =>{
  //   navigate("/Parent/Registration")
  // }
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.email || !formData.password) {
      toast.error('All fields are required')
      return
    }
    if (!isLogin && formData.password !== formData.confirm) {
      toast.error('Passwords do not match.')
      return
    }
    if (isLogin) {
      login({
        user_type: formData.user_type,
        email: formData.email,
        password: formData.password,
      })
    } else {
      signUp({
        user_type: formData.user_type,
        // name: formData.name,
        email: formData.email,
        password: formData.password,
      })
    }
  }
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  return (
    <>
      <style>
        {`
        .slide-right-left-enter {
          max-width: 0;
          overflow: hidden;
          transition: max-width 0.5s ease, opacity 0.5s ease;
          opacity: 0;
        }

        .slide-right-left-enter-active {
          max-width: 500px; /* adjust width as needed */
          opacity: 1;
        }

        .slide-right-left-exit {
          max-width: 500px;
          opacity: 1;
          overflow: hidden;
        }

        .slide-right-left-exit-active {
          max-width: 0;
          opacity: 0;
          transition: max-width 0.5s ease, opacity 0.5s ease;
        }

      .mobile-margin {
        margin-top: -4.5rem; /* default (desktop) */
      }

      @media (max-width: 768px) {
        .mobile-margin {
          margin-top: 0rem; /* only on mobile */
        }
      }
      `}
      </style>
      <div className="container-fluid  d-flex flex-column flex-md-row p-0">
        <div
          className="d-none d-md-block bg-primary vh-100 overflow-hidden w-100"
          style={{
            marginTop: '-1rem',
            marginLeft: '-1rem',
            marginBottom: '-2rem',
          }}
        ></div>

        <div className="w-100 d-flex flex-column align-items-center justify-content-start justify-content-md-center p-3">
          <Card
            className="p-4 border-0 mobile-margin"
            style={{
              // marginTop:"-2rem",
              width: '100%',
              maxWidth: '500px',
              borderRadius: '15px',
              height: '90%',
              // "@media(max-width:768px)":{
              //   marginTop:"17rem"
              // }
            }}
          >
            <img
              src="/tta_logo.jpg"
              alt="Logo"
              style={{
                height: '180px',
                objectFit: 'contain',
                marginTop: '-10px',
                marginBottom: '20px',
              //    "@media(max-width:768px)":{
              //   marginTop:"27rem"
              // }
              }}
            />

            <h2 className="text-center mb-3 text-primary fw-bold">
              {isLogin ? 'WELCOME BACK !' : 'Signup Form'}
            </h2>
            <p className="text-muted fw-bold">Please login to your account</p>

            <Form.Group className="mb-4 text-start fw-semibold">
              <Form.Label>Login As</Form.Label>
              <Form.Select
                name="user_type"
                value={formData.user_type}
                onChange={handleChange}
                className="rounded-pill"
                required
              >
                <option value="">Select</option>
                <option value="admin">Admin</option>
                <option value="teacher">Teacher</option>
                <option value="accountant">Accountant</option>
                <option value="marketer">Marketer</option>
                <option value="parents">Guardian</option>
              </Form.Select>
            </Form.Group>

            <Form onSubmit={handleSubmit} className="text-start">
              {!isLogin && (
                <Form.Group className="mb-3 fw-semibold">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Your Name"
                    className="rounded-pill"
                    required
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-3 fw-semibold">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Your Email"
                  className="rounded-pill"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4 fw-semibold">
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter Your Password"
                    className="rounded-pill pe-5"
                    required
                  />
                  <Button
                    variant="link"
                    className="position-absolute end-0 top-50 translate-middle-y me-2"
                    onClick={togglePasswordVisibility}
                    style={{ textDecoration: 'none', border: 'none' }}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaEye size={20} />
                    )}
                  </Button>
                </div>
              </Form.Group>

              {!isLogin && (
                <Form.Group className="mb-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="text"
                    name="confirm"
                    value={formData.confirm}
                    onChange={handleChange}
                    placeholder="Confirm Your Password"
                    className="rounded-pill"
                    required
                  />
                </Form.Group>
              )}

              <Button
                type="submit"
                className="w-100 mt-3 fw-bold"
                variant="primary"
              >
                {isLogin ? 'Login' : 'Signup'}
              </Button>
          </Form>
          {/* <Button
            variant="link"
            style={{ cursor: 'pointer', letterSpacing: '1px' }}
            className="text-end fw-semibold text-decoration-underline"
            onClick={()=>navigate("/Parent/Registration")}
          >
            Register As Parent
          </Button> */}

          </Card>
           
        </div>
        {/* <CSSTransition
          in={openForgotModal}
          timeout={500}
          classNames="slide-right-left"
          unmountOnExit
          nodeRef={forgotRef}
        >
          <div
            ref={forgotRef}
            style={
              isMobileForgotPass
                ? { marginTop: '10px', zIndex: 1051 }
                : {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1050,
                  }
            }
          >
            <ForgotPassword
              hide={() => setOpenForgotModal(false)}
              data={formData}
            />
          </div>
        </CSSTransition> */}
    

      </div>
    </>
  )
}
